import { ReactNode } from "react";
import { useAuth } from "../context/AuthContext";
import { Alert, AlertDescription, AlertTitle } from "./ui/alert";

/** Wraps children; shows "Access restricted" alert if the user lacks the perm. */
export function PermissionGate({
  perm,
  children,
}: {
  perm: string;
  children: ReactNode;
}) {
  const { isAdmin, permissions } = useAuth();
  if (isAdmin || permissions.has(perm)) {
    return <>{children}</>;
  }
  return (
    <Alert variant="destructive">
      <AlertTitle>Access restricted</AlertTitle>
      <AlertDescription>
        You do not have permission to view this page.
      </AlertDescription>
    </Alert>
  );
}
